<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" style="padding: 0;">
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="$router.push({
            name: 'Home'
          });"
        >
          Menú
        </v-btn>
        <br/>
        <br/>
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12" style="padding: 0;">
         <iframe :src="urlClock" style="max-width: 100%;width: 100%;min-height: 1500px;border: none;height: auto;" v-if="showFrame"></iframe>
        
        </v-col>
        
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>

import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: "Clock",
    components: {
        // CardIeaApp,
        CardIeaAppMain,
    },

    data: () => ({
        urlClock:'https://clockradar.com/third-party/iea/',
        showFrame:false
    }),

    mounted() {
        if(this.$store.getters.user.borrado == 1 || this.$store.getters.user.excedente){
          this.$router.push({
              name: "Home"
            });
        }
        //ignaciochiara@institutoiea.edu.ar/44756517/Ignacio/Chiara
        console.log(this.user)
        
        this.getUserLogged();
        this.addVisit();
    },

    computed: {
        user() {
          return this.$store.getters.user;
        },
    },
    methods: {
        async getUserLogged(){
            this.$API
              .get({
                    url: "alumno/getAlumno"
                }).then((res) => {
                console.log('alumno', res)
                this.urlClock += res.Email.trim()+'/'+res.key.trim()+'/'+res.Nombres.trim()+'/'+res.Apellidos.trim();
                //this.urlClock += 'ignaciochiara@institutoiea.edu.ar/44756517/Ignacio/Chiara';
                this.showFrame = true;
                
              });
        },
        async addVisit(){
            this.$API
              .post({
                    url: "add-visit-kanban"
                }).then((res) => {
                console.log(res)
              });
        },

    }
};
</script>